<template>
  <el-scrollbar style="width: 100%; overflow-x: hidden;">
    <div class="page" ref="pageRef">
      <div class="shadow-box">
        <!-- 报表数据汇总 -->
        <div class="summary-card">
          <div class="summary-card__header">
            <img src="@/assets/images/icon-total.png" />
            <span>高佣结算佣金报表</span>
          </div>
          <div class="summary-card__body">
            <div class="summary-item">
              <div class="summary-value">{{ summaryData.totalReportCount || 0 }}</div>
              <div class="summary-label">总报表数</div>
            </div>
            <div class="summary-item">
              <div class="summary-value">{{ summaryData.totalOrderCount || 0 }}</div>
              <div class="summary-label">总订单数</div>
            </div>
            <div class="summary-item">
              <div class="summary-value">
                <span class="primary-color">
                  <span style="font-size: 14px">¥</span>{{ formatMoney(summaryData.totalAmount) }}</span>
              </div>
              <div class="summary-label">总金额</div>
            </div>
          </div>
        </div>

        <div class="page-main_box" style="height: auto;">
          <!-- 搜索区域 -->
          <div class="search-box" style="padding-top: 6px;">
            <el-row :gutter="12" type="flex" align="middle">
              <el-col :span="6">
                <div class="search-item">
                  <div class="label">报表名称：</div>
                  <el-input v-model="form.fileName" clearable placeholder="搜索报表名称"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="search-item">
                  <div class="label">结算状态：</div>
                  <el-select clearable style="width: 100%;" multiple collapse-tags v-model="form.statusList" placeholder="全部状态">
                    <el-option v-for="item in settleStatusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="search-item">
                  <el-button type="primary" @click="goSearch">查 询</el-button>
                  <el-button type="primary" @click="handleUploadPayInfo">上传收款信息</el-button>
                  <span class="red tip" v-if="hasChannelReceipt">
                    <i class="el-icon-warning"></i>
                    如果收款账户有变更，请及时更新收款账户
                  </span>
                </div>
              </el-col> 
            </el-row>
          </div>

          <!-- 表格 -->
          <div class="code-list-content">
            <el-table
              border
              stripe
              ref="tableRef"
              :data="tableData"
              v-loading="isLoading"
            >
              <el-table-column
                type="index"
                label
                fixed
                width="40">
              </el-table-column>
              <el-table-column
                prop="fileName"
                label="报表名称" fixed
                min-width="180">
                <template slot-scope="{ row }">
                  <div>
                    <img src="@/assets/images/icon-excel.png" class="icon-excel" />
                    {{ row.fileName }}
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="channelAccountName"
                label="聚合渠道昵称"
                min-width="130"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="parentChannelAccountName"
                label="一级渠道昵称"
                min-width="130"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="subChannelAccountName"
                label="二级渠道昵称"
                min-width="130"
                show-overflow-tooltip>
              </el-table-column> -->
              <el-table-column
                prop="status"
                label="结算状态"
                min-width="100">
                <template slot-scope="{ row }">
                  <el-tag :type="getStatusTagType(row.status)" size="small">
                    {{ getStatusLabel(row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="settlementDate"
                label="结算日期"
                min-width="120">
                <template slot-scope="{ row }">
                  {{ row.settlementDate | filterDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="orderCount"
                label="订单数"
                min-width="90">
              </el-table-column>
              <el-table-column
                prop="settlementAmount"
                label="结算佣金金额"
                min-width="130">
                <template slot-scope="{ row }">
                  <span class="red">+¥{{ row.settlementAmount || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="上传时间"
                min-width="120">
                <template slot-scope="{ row }">
                  {{ row.createTime | filterDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="financeRemark"
                label="财务备注"
                min-width="160"
                show-overflow-tooltip>
                <template slot-scope="{ row }">
                  {{ row.financeRemark || '' }}
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="220"
                fixed="right">
                <template slot-scope="{ row }">
                  <el-button type="text" @click="handleDownload(row)">下载</el-button>
                  <!-- 已经打款了 -->
                  <el-button type="text" v-if="row.status === 'PAID'" @click="handleViewPayProof(row)">查看打款凭证</el-button>
                  <el-button type="text" v-if="row.status !== 'PAID'" @click="handleConfirmReport(row)">确认报表</el-button>
                  <el-button type="text" v-if="row.status == 'PAID'" style="color: #2BA471 !important;" @click="handleUploadInvoice(row)">上传发票</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="bd--pag">
              <!-- <div>
                <span style="color: #999; font-size: 12px;">共 {{ pageInfo.total }} 项数据</span>
              </div> -->
              <el-pagination
                v-if="pageInfo.total > 0"
                class="d-ib"
                background
                layout="sizes, prev, pager, next, jumper"
                :total="pageInfo.total"
                :page-sizes="pageInfo.sizes"
                :page-size="pageInfo.size"
                :current-page="pageInfo.current"
                @current-change="pageInfo.current = arguments[0], getList()"
                @size-change="pageInfo.size = arguments[0], getList()">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- 确认报表弹框 -->
      <ConfirmReportDialog
        v-if="showConfirmDialog"
        v-model="showConfirmDialog"
        :row="currentRow"
        @close="showConfirmDialog = false"
        @on-success="confirmSuccessHandler"
      />
      <!-- 上传发票弹框 -->
      <UploadInvoiceDialog
        v-if="showInvoiceDialog"
        v-model="showInvoiceDialog"
        :row="invoiceRow"
        @close="showInvoiceDialog = false"
        @on-success="getList"
      />
      <!-- 收款账户列表弹框 -->
      <ReceiptAccountListDialog
        v-model="showPayInfoDialog"
        @close="showPayInfoDialog = false"
        @on-success="refreshReceiptStatus"
      />
      <!-- 旧版上报收款信息弹框（保留） -->
      <!-- <UploadPayInfoDialog v-model="showPayInfoDialog" @close="showPayInfoDialog = false" /> -->
      <!-- 打款凭证弹框 -->
      <PayProofDialog
        v-if="showPayProofDialog"
        v-model="showPayProofDialog"
        :row="payProofRow"
        @close="showPayProofDialog = false"
      />
    </div>
  </el-scrollbar>
</template>

<script>
import ConfirmReportDialog from './components/confirm-report-dialog.vue'
import UploadInvoiceDialog from './components/upload-invoice-dialog.vue'
import ReceiptAccountListDialog from './components/receipt-account-list-dialog.vue'
import PayProofDialog from './components/pay-proof-dialog.vue'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { getUserId } from '@/utils/getUser' 
const dayjs = require('dayjs')

// 导出表头配置
const EXPORT_HEADERS = ['表单名称',
  '上游订单号', '后台渠道昵称', '报单佣金', '结算佣金', '已结算佣金',
  '结算日期', '最终结算金额', '佣金占比', '渠道用户id',
  '购买者openId', '购买者rebateAccountId', '商品名称', '支付金额', '订单状态',
  '支付时间', '确认收货时间', '更新时间', '平台', '创建时间',
  '补贴是否有效', '补贴失效原因', '店铺名称', '小程序链接', '风险标识',
  '一级渠道昵称', '二级渠道昵称',
  '下游昵称', '下游id'
]
// data 对象中对应的字段 key（与表头顺序一致）
const DATA_KEYS = ['fileName',
  'thirdOrderSn', 'channelAccountName', 'reportCommission', 'settlementCommission', 'settledCommission',
  'settlementDate', 'finalSettlementAmount', 'commissionRatio', 'userId',
  'buyerOpenId', 'buyerRebateAccountId', 'goodsName', 'payAmount', 'orderStatus',
  'payTime', 'confirmReceiveTime', 'orderUpdateTime', 'platform', 'orderCreateTime',
  'subsidyValid', 'subsidyInvalidReason', 'shopName', 'miniProgramLink', 'riskFlag',
  'parentChannelNickName', 'subChannelNickName',
  'downstreamNickName', 'downstreamId'
]
function formatDateTime (arr) {
  const [year, month, day, hour, minute, second] = arr;
  const pad = (n) => String(n).padStart(2, '0');
  return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}:${pad(second)}`;
}

const settleStatusList = [
  { label: '待确认', value: 'PENDING_CONFIRM' },
  { label: '待打款', value: 'PENDING_PAYMENT' },
  { label: '有异议', value: 'DISPUTED' },
  { label: '已打款', value: 'PAID' }
]

const settleStatusMap = {
  'PAID': { label: '已打款', type: 'success' },
  'DISPUTED': { label: '有异议', type: 'warning' },
  'PENDING_PAYMENT': { label: '待打款', type: 'danger' },
  'PENDING_CONFIRM': { label: '待确认', type: 'info' }
}

export default {
  name: 'SettlementManage',
  components: { ConfirmReportDialog, UploadInvoiceDialog, ReceiptAccountListDialog, PayProofDialog },
  data() {
    return {
      settleStatusList,
      hasChannelReceipt: false,
      form: {
        fileName: '',
        settleDate: [],
        statusList: []
      },
      pageInfo: {
        current: 1,
        size: 20,
        sizes: [10, 20, 30, 50, 100],
        total: 0
      },
      isLoading: false,
      tableData: [{}, {}, {}],
      summaryData: {
        totalReportCount: 0,
        totalOrderCount: 0,
        totalAmount: 0
      },
      showConfirmDialog: false,
      currentRow: {},
      showInvoiceDialog: false,
      invoiceRow: {},
      showPayInfoDialog: false,
      showPayProofDialog: false,
      payProofRow: {}
    }
  },
  filters: {
    filterDate(date='') {
      if (date) {
        if (Array.isArray(date)) {
          return formatDateTime(date)
        }
        return dayjs(date).format('YYYY-MM-DD')
      }
      return '--'
    }
  },
  created() {
    this.getList()
    this.getSummary()
    this.checkPayInfoOncePerDay()
  },
  methods: {
    // 每天只检查一次是否绑定收款信息
    checkPayInfoOncePerDay() {
      const KEY = 'PAY_INFO_CHECK_DATE'
      const today = new Date().toLocaleDateString()
      const lastCheckDate = localStorage.getItem(KEY)
      this.$http('get', 'mall/bdM2sSettlementChannelReceipt/list', {
        page: 1,
        pageSize: 100
      }).then(res => {
        const records = (res && res.data) || []
        const hasBankReceipt = records.some(item => item.status === 1 && item.bankName !== '支付宝')
        this.hasChannelReceipt = hasBankReceipt
        const shouldShow = !hasBankReceipt && (!lastCheckDate || lastCheckDate !== today)
        if (shouldShow) {
          localStorage.setItem(KEY, today)
          this.$confirm('尊敬的用户你好，你的收款账户信息还没有进行维护，请进行维护，否则会影响你的佣金到账。', '提示', {
            confirmButtonText: '去维护',
            cancelButtonText: '稍后再说',
            type: 'warning'
          }).then(() => {
            this.showPayInfoDialog = true
          }).catch(() => {})
        }
      }).catch(() => {})
    },
    refreshReceiptStatus() {
      this.$http('get', 'mall/bdM2sSettlementChannelReceipt/list', {
        page: 1,
        pageSize: 100
      }).then(res => {
        const records = (res && res.data) || []
        this.hasChannelReceipt = records.some(item => item.status === 1 && item.bankName !== '支付宝')
      }).catch(() => {})
    },
    formatMoney(amount) {
      if (amount === null || amount === undefined) return '0'
      return Number(amount).toLocaleString('zh-CN', { minimumFractionDigits: 0 })
    },
    getStatusTagType(status) {
      return (settleStatusMap[status] && settleStatusMap[status].type) || 'info'
    },
    getStatusLabel(status) {
      return (settleStatusMap[status] && settleStatusMap[status].label) || '--'
    },
    showUploadInvoice(row) {
      // 已打款状态显示上传发票
      return row.settleStatus === 1
    },
    showConfirmReport(row) {
      // 待确认/有异议状态显示确认报表
      return row.settleStatus === 4 || row.settleStatus === 2
    },
    goSearch() {
      this.pageInfo.current = 1
      this.getList()
      this.getSummary()
    },
    getParams() {
      const form = JSON.parse(JSON.stringify(this.form))
      const params = {}
      if (form.fileName) {
        params.fileName = form.fileName
      }
      if (form.statusList.length) {
        params.statusList = [...form.statusList]
      }
      return params
    },
    getList() {
      this.isLoading = true
      this.tableData = []
      const params = this.getParams()
      this.$http('post', 'mall/bdM2sSettlementReport/page', {
        ...params,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }).then(res => {
        const { records, total } = res || {}
        this.tableData = records || []
        this.pageInfo.total = total || 0
      }).catch(() => {}).finally(() => {
        this.isLoading = false
      })
    },
    getSummary() {
      const params = this.getParams()
      this.$http('post', 'mall/bdM2sSettlementReport/statistics', params).then(res => {
        this.summaryData = res || {}
      }).catch(() => {})
    },
    
    handleDownload(row) {
      if (row.filePath) {
        const fileName = (row.fileName || '报表') + '.xlsx'
        fetch(row.filePath)
          .then(res => res.blob()).then(blob => {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = fileName
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)
          }).catch(() => {
            this.$message.error('下载失败')
          })
      } else {
        this.$http('post', 'mall/bdM2sSettlementReport/orderList?settlementDate=' + row.settlementDate).then(res => {
          if (res && res.length) {
            this.exportExcel(res.map(item => {
              return {
                ...item,
                userId: getUserId(),
                fileName: row.fileName
              }
            }))
          }
        }).catch(() => {})
      }
    },
    exportExcel (rowList) {
      // 需要强制文本显示的字段（订单号、ID类），避免科学计数法
      const TEXT_KEYS = [
        'thirdOrderSn', 'parentChannelAccountId', 'subChannelAccountId',
        'buyerOpenId', 'buyerRebateAccountId', 'downstreamId', 'userId'
      ]
      // 金额字段，保留2位小数
      const MONEY_KEYS = [
        'reportCommission', 'settlementCommission', 'settledCommission',
        'finalSettlementAmount', 'payAmount'
      ]
      const data = [EXPORT_HEADERS]
      rowList.forEach(item => {
        const values = DATA_KEYS.map(key => {
          let val = item[key]
          if (val === null || val === undefined) val = ''
          if (Array.isArray(val)) val = formatDateTime(val)
          if (MONEY_KEYS.includes(key)) val = Number(val || 0).toFixed(2)
          if (TEXT_KEYS.includes(key) && val !== '') val = '\'' + val
          return val
        })
        data.push(values)
      })

      const worksheet = XLSX.utils.aoa_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      })

      const dataBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      })
      saveAs(dataBlob, `${rowList[0]['fileName'] || '高佣结算佣金报表'}.xlsx`)
    },
    handleViewPayProof(row) {
      this.payProofRow = row
      this.showPayProofDialog = true
    },
    handleUploadInvoice(row) {
      this.invoiceRow = row
      this.showInvoiceDialog = true
    },
    handleConfirmReport(row) {
      this.currentRow = row
      this.showConfirmDialog = true
    },
    confirmSuccessHandler() {
      this.showConfirmDialog = false
      this.getList()
      this.getSummary()
    },
    handleUploadPayInfo() {
      this.showPayInfoDialog = true
    }
  }
}
</script>

<style scoped>
/* 汇总卡片 */
.summary-card {
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
  background: url(https://img.bpshe.com/common/2026/03/25/5327cd5ae4ebf5314fe94053732aac2f.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.summary-card__header {
  padding: 12px 0 0 12px;
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #333;
  font-weight: 500;
}
.summary-card__header img {
  width: 20px;
  height: 20px;
  margin-right: 3px;
}
.summary-card__header i {
  margin-right: 6px;
  color: #1990FF;
}
.summary-card__body {
  display: flex;
  padding: 20px 0;
}
.summary-item {
  padding-right: 32px;
  text-align: center;
  padding-left: 24px;
  border-right: 1px solid #e8ecf2;
}
.summary-item:last-child {
  border-right: none;
}
.summary-value {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  margin-bottom: 6px;
}
.summary-value.red {
  color: rgba(232, 0, 0, 1);
}
.summary-label {
  font-size: 13px;
  color: #999;
}

/* 搜索区域 */
.search-box .flex-row {
  padding-bottom: 8px;
}
.search-item {
  margin-right: 0;
  padding-bottom: 8px;
}

/* 表格 */
.red {
  color: rgba(232, 0, 0, 1);
  font-weight: 500;
}
.bd--pag {
  background: #fff;
  position: sticky;
  bottom: 0;
  margin-top: 0;
  padding: 10px 0;
  z-index: 9;
}
.shadow-box {
  box-shadow: none;
  border-radius: none;
  padding: 0;
}
.page {
  height: calc(100vh - 62px);
  overflow: auto;
  overflow-x: hidden;
  padding: 0 12px;
  box-sizing: border-box;
  width: 100%;
}
.page-main_box {
  width: 100%;
  min-width: 0;
  overflow: hidden;
}
.search-item {
  line-height: 32px;
  display: flex;
}
.search-item .label {
  color: #666;
  font-size: 14px;
  white-space: nowrap;
}
.code-list-content {
  width: calc(100vw - 256px);
}
.icon-excel {
  vertical-align: middle;
  width: 14px;
  height: 16px;
}
.tip {
  padding-left: 12px;
  color: red;
}
</style>
